import { ToastType } from "./toast-type.enum";

export default class Toast {
  constructor(
    public message: string,
    public type: ToastType = ToastType.INFO
  ) {}
}
